document.addEventListener('DOMContentLoaded', function() {
    const today = new Date();
    const deliveryDate = new Date(today);
    deliveryDate.setDate(today.getDate() + 5); // Add 5 days

    const options = { weekday: 'long', month: 'long', day: 'numeric' };
    const formattedDate = deliveryDate.toLocaleDateString('en-US', options);
    
    const deliveryMessage = `Estimated delivery by ${formattedDate}`;

    // Find a suitable place to insert the message
    const productDetails = document.querySelector('.product-single__description');
    if (productDetails) {
        const messageElement = document.createElement('p');
        messageElement.textContent = deliveryMessage;
        productDetails.appendChild(messageElement);
    }
});
